import { render, staticRenderFns } from "./ModalPremiumComment.vue?vue&type=template&id=24dbda96&scoped=true&"
import script from "./ModalPremiumComment.vue?vue&type=script&lang=js&"
export * from "./ModalPremiumComment.vue?vue&type=script&lang=js&"
import style0 from "./ModalPremiumComment.vue?vue&type=style&index=0&id=24dbda96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dbda96",
  null
  
)

export default component.exports